@if (!isUrlDisabled && !showLoader) {
<div role="main" class="fc-page">
  <app-header [isDashboard]="true"></app-header>
  <app-progress-bar [currentStep]="1"></app-progress-bar>
  <app-meta-bar></app-meta-bar>

  <section class="fc-panel">
    <div class="fc-panel-header">
      <h2>Enter Reference ID</h2>
    </div>
    <form [formGroup]="referenceForm" (ngSubmit)="Next()">
      <div class="fc-panel-body">
        <p class="fc-instructions">Please locate the Reference ID within the letter you received to add into the text field and then click enter. This ID is used to link your submission to the correct case.</p>

        <label for="Reference-id" class="reference-label">Reference ID <span class="fc-required-text">(Required)</span></label>
        <div class="fc-input-row fc-input-width">
          <input type="text" name="referenceNumber" maxlength="60" formControlName="referenceNumber"
            class="form-control fc-required-glow" [class.force-required-glow]="referenceForm.get('referenceNumber')?.hasError('required')"
            id="Reference-id" placeholder="Enter Reference ID">
          <button class="btn-clear" id="clearButton" type="button" (click)="clear()"
            [disabled]="referenceForm.get('referenceNumber')?.value === ''">Clear</button>
        </div>

        @if (error) {
          <div class="mt-3"><span class="text-danger">{{ errorMessage }}</span></div>
        }
      </div>

      <div class="fc-panel-footer">
        <button class="btn-enter" id="dashboardButton" type="submit"
          [disabled]="referenceForm.invalid"
          [ngbTooltip]="referenceForm.invalid ? 'Please enter a Reference ID to proceed' : ''"
          [tooltipClass]="'tooltip-disabled'">Continue &gt;</button>
      </div>
    </form>
  </section>

  <app-footer [positionFixed]="false"></app-footer>
</div>
}

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-scale-multiple"
    [fullScreen]="true">
    <p style="color: white">Please do not Cancel or Refresh page</p>
</ngx-spinner>

@if (isUrlDisabled && !showLoader) {
<div class="container" role="main">
  <div class="row main-home py-0">
    <div class="col-md-12">
      <h1 role="heading" aria-level="1">Please verify the URL that you are attempting to access.</h1>
    </div>
  </div>
</div>
}
